export default{
    install(Vue){
        
        //配置信息
        var $winConfig = {
            isLogin: false,
            shareConfig:{
                url: "http://5sing.kugou.com/subject/tgm/index",
                title: '腾讯动漫“遇见不一样的世界”国漫音乐大赛正式开启',
                image: "http://static.5sing.kugou.com/topic/tgm/images/share.jpg",
                description: '腾讯动漫国漫音乐大赛在5sing火热开启！施展你的才华，助力国漫音乐！万元现金大奖、2018国漫演唱会优先邀约资格！更有机会为国漫新作创作新歌~我们想与你一起，遇见不一样的国漫世界！@腾讯动漫@国漫演唱会 @原创音乐基地',
                description4Wsing: "腾讯动漫国漫音乐大赛在5sing火热开启！想翻唱你最爱的国漫神曲吗？想为你最爱的国漫创作歌曲吗？我们想与你一起，遇见不一样的国漫世界！更有万元大奖！快来参与～(活动地址：[url=http://5sing.kugou.com/subject/tgm/index]点击进入[/url])"
            },
            //报名配置信息  测试
            // activityId : "16P7TngDskk=",  
            // voteColumnId : "lFsbUmHHMjo=",
            // signConfig:[
            //     {
            //         text: "原创",
            //         id: "wQpxtUcIcZA=",
            //         type: "yc",
            //     },
            //     {
            //         text: "翻唱",
            //         id: " 0I7TYyT25c8=",
            //         type: "fc",
            //     }
            // ],
            //报名配置信息  正式
            activityId : "6U63ZtyJ0MQ=",  
            voteColumnId : "Co940pelN28=",
            signConfig:[
                {
                    text: "原创",
                    id: "ZzzSoLottGQ=",
                    type: "yc",
                },
                {
                    text: "翻唱",
                    id: "rKP2ImFlSAs=",
                    type: "fc",
                }
            ],

            //视频配置信息
            videoConfig: {
                width: '800',
                height: '450',
                videoList: [
                    {
                        src: "http://fx.v.kugou.com/G137/M03/1F/13/yQ0DAFuHYFeACCVFAPmeg7LxD1c519.mp4",
                        name: "",
                        screenshort: "http://static.5sing.kugou.com/5sing/activity/glory/img/video_m.jpg",
                        poster: 'http://static.5sing.kugou.com/5sing/activity/tgm/img/video1.jpg'
                    }
                ]
            }
        };

        Vue.winConfig = Vue.prototype.$winConfig = $winConfig;
    }
}


// WEBPACK FOOTER //
// ./src/components/config.js